(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('BudgetDetailController', BudgetDetailController);

    /*BudgetDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'Budget'];

    function BudgetDetailController($scope, $rootScope, $stateParams, DataUtils, Budget) {
    	var vm = this;

        vm.budget = [{code:'C1',type:'PS Sales', budgetHolder:'Nguyễn Quý Trinh',description:'PYC, Hóa đơn....',status:'1'},
	                  {code:'CSS_S',type:'CSS_Sales', budgetHolder:'Nguyen Van A',description:'PYC, Hóa đơn....',status:'1'},
	                  {code:'NBN_S',type:'NB North_Sales', budgetHolder:'Nguyễn Quý Hóa',description:'PYC, Hóa đơn....',status:'1'}];*/
        
    BudgetDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils','entity','Budget'];

    function BudgetDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Budget) {
        var vm = this;
        vm.budget = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.budget.status == 1){
        	vm.budget.statusName = 'Đang hoạt động'
        }else{
        	vm.budget.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:budgetUpdate', function(event, result) {
            vm.budget = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
